import { Injectable } from "@angular/core";
import { ComponentStore } from "@ngrx/component-store";
import { Observable } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { DeleteNewsletterTemplateState } from "./delete-newsletter-template.state";
import { NewsletterTemplateService } from "src/app/services/newsletter-template.service";

const initialState: DeleteNewsletterTemplateState = {
    loading: false,
    loaded: false,
    success: false,
    errorMessage: null
};

@Injectable({
    providedIn: 'root'
})
export class DeleteNewsletterTemplateComponentStore extends ComponentStore<DeleteNewsletterTemplateState> {

    constructor(private readonly newsletterTemplateService: NewsletterTemplateService) {
        super(initialState);
    }

    readonly loading$: Observable<boolean> = this.select(state => state.loading);
    readonly loaded$: Observable<boolean> = this.select(state => state.loaded);
    readonly success$: Observable<boolean> = this.select(state => state.success);
    readonly errorMessage$: Observable<any> = this.select(state => state.errorMessage);

    readonly viewModel$ = this.select(
        this.loaded$,
        this.loading$,
        this.success$,
        this.errorMessage$,
        (loaded, loading, success, errorMessage) => ({
            loaded, loading, success, errorMessage
        })
    );

    readonly setInitial = this.updater((_: DeleteNewsletterTemplateState) => {
        return {
            ...initialState
        };
    });

    readonly setLoading = this.updater((state: DeleteNewsletterTemplateState) => {
        return {
            ...state,
            loading: true,
            loaded: false,
        };
    });

    readonly setLoaded = this.updater((state: DeleteNewsletterTemplateState) => {
        return {
            ...state,
            loading: false,
            loaded: true,
        };
    });

    readonly updateDeleteNewsletterTemplateState = this.updater((state: DeleteNewsletterTemplateState) => {
        return {
            ...state,
            loading: false,
            loaded: true,
            success: true,
        };
    });

    readonly setError = this.updater((state: DeleteNewsletterTemplateState, value: {
        errorMessage: String
    }) => {
        return {
            ...state,
            loading: false,
            loaded: true,
            success: false,
            errorMessage: value.errorMessage,
        };
    });

    readonly deleteNewsletterTemplate = this.effect((params$: Observable<{ companyId: string, newsletterTemplateId: string }>) => {
        this.setLoading();
        return params$.pipe(
            switchMap((params => this.newsletterTemplateService.deleteNewsletterTemplate(params.companyId, params.newsletterTemplateId).pipe(
                map(() => {
                    this.updateDeleteNewsletterTemplateState()
                    this.setLoaded();
                    this.setInitial();

                }),
                catchError(async (error) => {
                    this.setError({ errorMessage: error });
                    this.setLoaded();
                    this.setInitial();
                })
            ))
            )
        );
    });
}